import React, { createContext, useContext, ReactNode, useState, useEffect } from "react";
import { UserCallPermissions } from "../types/Authorization";
import { loggedUser } from "../types/User";
import { getReq } from "../utils/request";
import { getJwtToken } from "../utils/token";
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';

interface UserPermissionsContextProps {
    userCallPermissions: UserCallPermissions;
    setUserCallPermissions: React.Dispatch<
        React.SetStateAction<UserCallPermissions>
    >;
    currentUser: any;
    setCurrentUser: React.Dispatch<React.SetStateAction<any>>;
}
const defaultUserCallPermissions: UserCallPermissions = {
    userId: 0, 
    pages: [],
};
const UserPermissionsContext = createContext<UserPermissionsContextProps>({
    userCallPermissions: defaultUserCallPermissions,
    setUserCallPermissions: () => {},
    currentUser: null,
    setCurrentUser: () => {},
});

export const UserPermissionsProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [userCallPermissions, setUserCallPermissions] = useState<UserCallPermissions>(defaultUserCallPermissions);
    const [currentUser, setCurrentUser] = useState<any>(null);

    useEffect(() => {
        const fetchUserData = async () => {
            if (!currentUser) {
                try {
                    const token = getJwtToken();
                    
                    const user: loggedUser = jwtDecode(token as string);
                    if(user.pages)
                        {
                    const result = await getReq('users/' + user.userId);
                    if (result.status === 200) {
                        setCurrentUser(result.body);
                    }
                }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            }
        };

        fetchUserData();
    }, []);

    return (
        <UserPermissionsContext.Provider
            value={{ userCallPermissions, setUserCallPermissions, currentUser, setCurrentUser }}
        >
            {children}
        </UserPermissionsContext.Provider>
    );
};

export const useUserPermissions = () => {
    const context = useContext(UserPermissionsContext);

    if (!context) {
        throw new Error(
        "useUserPermissions must be used within a UserPermissionsProvider"
        );
    }

    return context;
};
